var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98098 11.5304L1.14098 7.69038C1.04498 7.59438 0.996976 7.47704 0.996976 7.33838C0.996976 7.19971 1.04498 7.08238 1.14098 6.98638C1.23698 6.87971 1.35431 6.82638 1.49298 6.82638C1.63164 6.82638 1.74898 6.87971 1.84498 6.98638L4.48498 9.61038V0.234375H5.49298V9.61038L8.13298 6.98638C8.22898 6.87971 8.34631 6.82638 8.48498 6.82638C8.62364 6.82638 8.74098 6.87971 8.83698 6.98638C8.93298 7.08238 8.98098 7.19971 8.98098 7.33838C8.98098 7.47704 8.93298 7.59438 8.83698 7.69038L4.98098 11.5304ZM0.500977 16.2344V15.2424H9.49298V16.2344H0.500977Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.619c54e5d983490b81f60c2887113a20.svg";
export { ForwardRef as ReactComponent };